import { useTranslation } from 'react-i18next';
import { translateTabName } from 'helpers';
import styles from './../../layouts/config-view/config-detail/dashboards/ConfigLayoutDashboards.module.css';

interface TemplateWarningBarProps {
  warnTabs: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const TemplateWarningBar = ({ warnTabs, onConfirm, onCancel }: TemplateWarningBarProps) => {
  const { t } = useTranslation();
  if (warnTabs.length === 0) return null;
  return (
    <div className={`alert alert-warning d-flex align-items-center justify-content-between gap-3 mb-0 rounded-0 border-start-0 border-end-0 ${styles.alertBar}`} role="alert">
      <div className="d-flex align-items-center gap-2">
        <span className={`material-icons ${styles.alertIcon}`}>warning</span>
        <span>
          <strong>
            {warnTabs.map((name) => translateTabName(name, t)).join(', ')}{' '}
            {t('VALIDATION.TAB_WORD', { count: warnTabs.length })}
          </strong>
          {' '}{t('VALIDATION.TEMPLATE_UNEDITED_WARNING')}
        </span>
      </div>
      <div className="d-flex gap-2 flex-shrink-0">
        <button onClick={onCancel} className="btn btn-sm btn-outline-warning">
          {t('ACTION.GO_BACK_AND_EDIT')}
        </button>
        <button onClick={onConfirm} className="btn btn-sm btn-warning">
          {t('ACTION.SAVE_ANYWAY')}
        </button>
      </div>
    </div>
  );
};